export default __webpack_public_path__ + "static/media/Acolyte's Belt of the Hallow Worlds.6e7f4103.jpg";